import { State } from "../enums";
import { WageAndTravelReimbursementRequestStatus } from "../enums/watr-reimbursement-request-status";
import { IWatrMileageTripDetail } from "./watr-mileage-trip-detail";
import { IWatrDecline } from "./watr-decline";
import { IWatrTrip } from "./watr-trip";

export interface IWatrRequestTravels {
    id: number,
    requestId: number,
    reimbursementId: number,
    status: WageAndTravelReimbursementRequestStatus,
    approverUserId?: number | null,
    approvedDateTime?: string | Date | null,
    approverName?: string | null,
    createdDateTime: Date,
    lastUpdated: Date,
    addressLine1: string,
    city: string,
    state: State,
    postalCode: string,
    roundTripMiles: number,
    roundTripInstances: IWatrMileageTripDetail[],
    roundTripInstancesJson: string,
    declines: IWatrDecline[],
    hotelLodgingExpense: number,
    flightAndTrainExpense: number,
    
    carServiceExpense: number,
    isCarServiceExpenseOverridden: boolean,
    overrideCarServiceExpense: number,

    dependentCareExpense: number,
    isDependentCareExpenseOverridden: boolean,
    overrideDependentCareExpense: number,

    mealExpense: number,
    isMealsOverWritten: boolean,
    overrideMeals: number,
    
    isMilesOverWritten: boolean,
    overrideMiles: number,

    reimbursableMiles: number,
    
    reimbursableMeals: number,
    totalMileageRequested: number,
    achRoutingNumber: string,
    achAccountNumber: string,
    requireDependentCare: boolean,
    requireDependentCompanion: boolean,
    requirePaymentAssistance: boolean,
    dependentCareFile: string,
    dependentCareFileUploadDate: Date,
    dependentCompanionFile: string,
    dependentCompanionFileUploadDate: Date,
    paymentAssistanceFile: string,
    paymentAssistanceFileUploadDate: Date,
    travelReceiptsFile: string,
    travelReceiptsFileUploadDate: Date,
    travelReceiptsTotal: number,
    travelReimbursementTotal: number,
    tlr: number,
    reimbursementAmount: number,
    previousReimbursementAmount: number,
    remainingReimbursementAmount: number,
    allowedReimbursementAmount: number,
    lineItems?: IWatrLineItem[],
    trips?: IWatrTrip[]
}

export interface IWatrLineItem {
    id: number,
    entityType: number,
    entityTypeId: number,
    expenseType: number,
    description: string,
    amount: number,
    receiptFileId?: number,
    createdDateTime: Date,
    lastUpdated?: Date,
    isApproved: boolean,
    approvedByUserId?: number,
    approvedDateTime?: Date,
    approvalNotes?: string,
    createdByUserId?: number,
    modifiedByUserId?: number,
    notes?: string,
    tripId?: number,
    reviewRequired: boolean,
    isDeclined: boolean,
    declinedByUserId?: number,
    declinedDateTime?: Date,
    declineReason?: string,
    reviewRequiredDescription?: string,
    isDeclinedDescription?: string,
    declineReasonFormatted?: string
}